import { render, staticRenderFns } from "./ContactsFragmentContactMetadata.vue?vue&type=template&id=52023e36&"
import script from "./ContactsFragmentContactMetadata.vue?vue&type=script&lang=js&"
export * from "./ContactsFragmentContactMetadata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports